import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { TelegramSenderLayout } from "../TelegramSenderLayout";
import { TelegramSenderRouterProps } from "../TelegramSenderRouterProps";

interface HomePageProps extends NSARouterMakerResult, TelegramSenderRouterProps { }

export default function HomePage(props: HomePageProps)
{
	return (
		<TelegramSenderLayout
			{...props}
		>
			<NSAHomePage
				{...props}
			/>
		</TelegramSenderLayout>
	);
}